import styled from 'styled-components'
import { Bubble } from '../../components'
import { media } from '../../theme/breakpoints'

export const DialogueContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px; /* Space between steps */
    text-align: start;
`

export const DialogueCard = styled(Bubble)<{
    $active?: boolean
    $hug?: boolean
}>`
    display: flex;
    flex-direction: column;
    gap: 10px;

    max-width: ${(p) => (p.$hug ? 'unset' : '480px')};
    margin-left: ${(props) => (props.$active ? '80px' : '0px')};
    width: fit-content;

    ${media.mobile} {
        margin-left: 0;
        width: 100%;
        max-width: 100%;
    }
`
